export const OPTHINES = {
  voteName: '2020project/2020hps',
  number: {
    mustRank: true,
  },
  themeColor: {
    activeBgColor: '#3B8DD4',
    inactiveBgColor: '#F1F1F1',
  },
  tabs: [
    {
      tabName: '相关新闻',
      tabPath: '/20200807JKMX/News',
    },
    {
      tabName: '活动须知',
      tabPath: '/20200807JKMX/Rules',
    },
    {
      tabName: '我要报名',
      tabPath: '/20200807JKMX/Third',
    },
    {
      tabName: '投票',
      tabPath: '/20200807JKMX/Fourth',
    },
  ],
};
